import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { Close } from '@mui/icons-material';
import { IconButton, Link as MuiLink } from '@mui/material';

import useStores from 'hooks/use-stores';
import OAuthButtonGroup from 'pages/components/OAuthButtonGroup';
import { useHubSpotOauthRedirect } from 'pages/hooks/use-hubspot-redirection';

import useStyles from './styles';

interface Props {
    className?: string;
}

const TIMEOUT = 5_000;

const LoginNotification: React.FC<Props> = ({ className }) => {
    const { userStore } = useStores();
    const { classes, cx } = useStyles();
    const { location } = useHistory();

    const oAuthProps = useHubSpotOauthRedirect({
        baseUrl: location.pathname + location.search,
        marketingAgreement: false
    });

    const timerRef = useRef<number>();
    const [isVisible, setIsVisible] = useState(false);

    const handleClose = useCallback(() => {
        clearTimeout(timerRef.current);
        setIsVisible(false);
    }, []);

    useEffect(() => {
        const shouldDisplay =
            !userStore.isAuthorized && ['development', 'beta', 'stable'].includes(window.__CONFIG__?.environment);
        if (shouldDisplay) {
            timerRef.current = window.setTimeout(() => setIsVisible(true), TIMEOUT);
        } else {
            handleClose();
        }

        return () => clearTimeout(timerRef.current);
    }, [handleClose, userStore.isAuthorized]);

    return isVisible ? (
        <div className={cx(classes.container, className)}>
            <p className={classes.title}>{'Get access to all data by sign in with'}</p>
            <OAuthButtonGroup {...oAuthProps} compact className={classes.oauthButtonGroup} />
            <p className={classes.hint}>
                {'Don’t have an account? '}
                <Link to="/signup" component={MuiLink} className={classes.link}>
                    {'Sign up'}
                </Link>
            </p>
            <IconButton size="small" onClick={handleClose} className={classes.close}>
                <Close />
            </IconButton>
        </div>
    ) : null;
};

export default observer(LoginNotification);
